import React from 'react'

export const LessonsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 16.5V4.83333M9 16.5C9 15.837 8.74714 15.2011 8.29706 14.7322C7.84697 14.2634 7.23652 14 6.6 14H1.8C1.58783 14 1.38434 13.9122 1.23431 13.7559C1.08429 13.5996 1 13.3877 1 13.1667V2.33333C1 2.11232 1.08429 1.90036 1.23431 1.74408C1.38434 1.5878 1.58783 1.5 1.8 1.5H5.8C6.64869 1.5 7.46263 1.85119 8.06274 2.47631C8.66286 3.10143 9 3.94928 9 4.83333M9 16.5C9 15.837 9.25286 15.2011 9.70294 14.7322C10.153 14.2634 10.7635 14 11.4 14H16.2C16.4122 14 16.6157 13.9122 16.7657 13.7559C16.9157 13.5996 17 13.3877 17 13.1667V12.0833M9 4.83333C9 3.94928 9.33714 3.10143 9.93726 2.47631C10.5374 1.85119 11.3513 1.5 12.2 1.5H16.2C16.4122 1.5 16.6157 1.5878 16.7657 1.74408C16.9157 1.90036 17 2.11232 17 2.33333V4M12.2 9L13.8 10.6667L17 7.33333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
